import { Col, Container, Image, Row, Stack } from "react-bootstrap"

const ExpertiseAngularDeveloper = () => {  
    return (
        // <Container className="expertise-angular-developer">
        //     <Row className="expertise-angular-developer-top-portion">
        //         <Col>
        //             <h2 className="section-title text-center">Expertise of <span>Angular Developers</span></h2>
        //             <p className="text-center">
        //                 Our dedicated Angular developers specialize in crafting robust solutions with the latest frameworks, delivering a wide range of Angular development services to our extensive clientele.
        //             </p>
        //         </Col>
        //     </Row>
        //     <Row className="expertise-angular-developer-bottom-portion">
        //         <Col md="4">
        //             <Stack className="expertise-angular-developer-bottom-portion-list">
        //                 <Image src="/images/multi-platform-support.png" alt="Multi Platform Support" fluid />
        //                 <label>Angular Framework Mastery</label>
        //                 <p>
        //                     Having a deep understanding of the Angular framework, our expert AngularJS developers efficiently use features like two-way data binding, dependency injection, and modular architecture to create robust, scalable, and maintainable applications.
        //                 </p>
        //             </Stack>
        //         </Col>
        //         <Col md="4">
        //             <Stack className="expertise-angular-developer-bottom-portion-list">
        //                 <Image src="/images/coding-standards.png" alt="Coding Standards" fluid />
        //                 <label>Angular Framework Mastery</label>
        //                 <p>
        //                     Having a deep understanding of the Angular framework, our expert AngularJS developers efficiently use features like two-way data binding, dependency injection, and modular architecture to create robust, scalable, and maintainable applications.
        //                 </p>
        //             </Stack>
        //         </Col>
        //         <Col md="4">
        //             <Stack className="expertise-angular-developer-bottom-portion-list">
        //                 <Image src="/images/trust-reliability.png" alt="Trust Reliability" fluid />
        //                 <label>RxJS and Observables</label>
        //                 <p>
        //                     With their expertise in RxJS and Observables, our Angular developers enhance application performance by offering reactive programming capabilities. They provide smooth interaction and effective data management, improving the general responsiveness of your Angular apps.
        //                 </p>
        //             </Stack>
        //         </Col>
        //         <Col md="4">
        //             <Stack className="expertise-angular-developer-bottom-portion-list">
        //                 <Image src="/images/tools-recommendations.png" alt="Tools Recommendations" fluid />
        //                 <label>Advanced Routing and Navigation</label>
        //                 <p>
        //                     Possessing advanced skills in routing and navigation, our developers can seamlessly orchestrate complex navigation flows. They leverage Angular's routing capabilities to create dynamic, user-friendly web applications with intricate navigation structures.
        //                 </p>
        //             </Stack>
        //         </Col>
        //         <Col md="4">
        //             <Stack className="expertise-angular-developer-bottom-portion-list">
        //                 <Image src="/images/complete-code-security.png" alt="Complete Code Security" fluid />
        //                 <label>RESTful API Integration</label>
        //                 <p>
        //                     Our team of skilled developers expertly integrates RESTful APIs to optimize data exchange. With proficiency in handling HTTP requests, they enhance app functionality and connectivity while delivering a robust and data-driven solution.
        //                 </p>
        //             </Stack>
        //         </Col>
        //         <Col md="4">
        //             <Stack className="expertise-angular-developer-bottom-portion-list">
        //                 <Image src="/images/testing-expertise.png" alt="Testing Expertise" fluid />
        //                 <label>Testing Expertise</label>
        //                 <p>
        //                     Proficient in unit, end-to-end, and behavior-driven development, our AngularJs developers validate code using top testing tools like Protractor, Jasmine, Karma, and more to deliver robust and error-free applications while enhancing its reliability.
        //                 </p>
        //             </Stack>
        //         </Col>
        //     </Row>
        // </Container>
        // src/pages/HireAngularJs.tsx
        
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>Hire Angular Developer</h2>
                        <p>
                            Looking to build a dynamic, responsive, and high-performing web application? Hire dedicated Angular developers from Webile Technologies to bring your vision to life. Our experienced Angular developers specialize in creating custom web solutions, single-page applications (SPAs), and enterprise-grade platforms using the latest Angular versions and best practices.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Our Angular Development Services Include:</h2>
                            <ul>
                                <li>5+ Years of Industry Experience</li>
                                <li>Flexible Hiring Models (Full-Time, Part-Time, Hourly)</li>
                                <li>Clean, Maintainable & Scalable Code</li>
                                <li>Strong Understanding of MVC Architecture</li>
                                <li>On-Time Delivery & Post-Launch Support</li>
                            </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Our AngularJS Development Services</h2>
                        <ul>
                            <li>Custom Angular Web App Development</li>
                            <li>Single Page Applications (SPA)</li>
                            <li>Angular UI/UX Development</li>
                            <li>API Integration & Development</li>
                            <li>Angular Migration & Upgradation</li>
                            <li>Maintenance & Support</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Why Hire Angular Developers from Us?</h2>
                        <ul>
                            <li>5+ Years of Industry Experience</li>
                            <li>Expertise in Angular 2+ to Angular 17</li>
                            <li>Clean, Scalable, and Maintainable Code</li>
                            <li>Strong Backend Integration with Node.js, Laravel, or PHP</li>
                            <li>Flexible Hiring Models (Hourly, Part-Time, Full-Time)</li>
                            <li>NDA & IP Protection</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Technologies We Use:</h2>
                        <p>Angular, RxJS, NgRx, TypeScript, HTML5, SCSS, REST APIs, Firebase, Node.js</p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Ready to Get Started?</h2>
                        <p>
                            Let’s discuss your project and help you find the perfect AngularJS developer. Contact us today to get a free consultation and quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>


    )
}

export default ExpertiseAngularDeveloper;